import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { LANGS, translations } from "./translations";

const STORAGE_KEY = "marchuk_lang";
const LanguageContext = createContext(null);

function applyLangToDocument(code) {
  const lang = LANGS.find((l) => l.code === code) || LANGS[0];
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", lang.code);
    document.documentElement.setAttribute("dir", lang.dir);
  }
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "tr";
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && LANGS.some((l) => l.code === stored)) return stored;
    return "tr";
  });

  useEffect(() => {
    applyLangToDocument(lang);
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      // ignore
    }
  }, [lang]);

  const t = useCallback(
    (path) => {
      const keys = path.split(".");
      let val = translations[lang] || translations.tr;
      for (const k of keys) {
        if (val && typeof val === "object" && k in val) {
          val = val[k];
        } else {
          val = undefined;
          break;
        }
      }
      if (val === undefined) {
        // fallback to Turkish
        let fb = translations.tr;
        for (const k of keys) {
          if (fb && typeof fb === "object" && k in fb) fb = fb[k];
          else {
            fb = path;
            break;
          }
        }
        return fb;
      }
      return val;
    },
    [lang]
  );

  const value = {
    lang,
    setLang,
    t,
    dir: LANGS.find((l) => l.code === lang)?.dir || "ltr",
    langs: LANGS,
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useT() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used within LanguageProvider");
  return ctx;
}
